import React from 'react';
import * as S from './compose-controls.styles';
import { mdiSend } from '@mdi/js';

interface IComposeControlsProps {
    locked: boolean;
    hasErrors: boolean;
    onSave: () => Promise<void>;
}

export const ComposeControls: React.FunctionComponent<IComposeControlsProps> = (
    props: IComposeControlsProps,
): React.ReactElement => {
    const { locked, hasErrors, onSave } = props;

    const save = async (): Promise<void> => {
        onSave();
    };

    return (
        <S.Controls>
            <S.UnderButton variant="primary" onClick={save} disabled={locked || hasErrors}>
                <S.SendIcon path={mdiSend} size={0.75} />
                Send
            </S.UnderButton>
        </S.Controls>
    );
};
